import { render, staticRenderFns } from "./Suppression.vue?vue&type=template&id=2766ff6c&scoped=true&"
import script from "./Suppression.vue?vue&type=script&lang=js&"
export * from "./Suppression.vue?vue&type=script&lang=js&"
import style0 from "./Suppression.vue?vue&type=style&index=0&id=2766ff6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766ff6c",
  null
  
)

export default component.exports